import { PhoneInputValue } from "../types";

export const inputValueToCustomerPhoneString = (value: PhoneInputValue) =>
  `${value.code.replace("+", "")}${value.phone}`;
